import React from 'react';
import { Box } from '@honda-canada/design-system-react';

const FieldWrapper = ({ fieldAction, children, fieldValidationErrorsComponent, errors }) => {
  const FieldValidationErrorsComponent = fieldValidationErrorsComponent;
  const hasErrorsThatCanBeDisplayed = FieldValidationErrorsComponent && errors;
  // Specific check for false not falsy
  if (fieldAction.enable === false) return null;
  return (
    <Box m="l">
      {children}
      {hasErrorsThatCanBeDisplayed && <FieldValidationErrorsComponent errors={errors} />}
    </Box>
  );
};

export default FieldWrapper;
